import { memo, useContext, useState } from "react";

// MUI
import { Box, Chip, CircularProgress } from "@mui/material";

// Icons
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import WarningIcon from "@mui/icons-material/Warning";
import DeleteIcon from "@mui/icons-material/Delete";

// Components
import { CustomTimeField } from "components/field/CustomTimeField";
import { Context } from "./Context";
import { getNegativeId } from "utils/GetNegativeId";
import moment from "moment";
import { gettingSimulatePunches } from "utils/Timecard";

const EditPunchCell = memo(({ params }) => {
	const [value, setValue] = useState("");
	const [error, setError] = useState(false);

	const { apiRef } = useContext(Context);

	const updateRow = (value) => {
		setValue(value);

		if (error || value === "") {
			return;
		}

		const new_punch = {
			id: getNegativeId(),
			total_span_index: getNegativeId(),
			type: params?.field === "punch_in" ? "in" : "out",
			date: params?.row?.date,
			time: value,
			date_time: `${params?.row?.date} ${value}`,
			missing: false,
			exception: false,
			hover: false,
			real: false,
		};

		if (params?.field === "punch_in") {
			params.row.punch_in = [...params.row.punch_in, new_punch];
		} else {
			params.row.punch_out = [...params.row.punch_out, new_punch];
		}

		apiRef.current.updateRows([params?.row]);
	};

	return (
		<>
			<Box
				sx={{
					width: "100%",
					display: "grid",
					placeItems: "center",
					alignItems: "center",
					alignContent: "center",
					gap: "10px",
					p: 1.5,
					mt: 0.5,
				}}
			>
				<CustomTimeField
					value={value}
					setValue={updateRow}
					error={error}
					setError={setError}
					ampm={false}
				/>
			</Box>
		</>
	);
});

const PunchChip = memo(
	({ punch, params, setAddOpenPaycode, setAction, setCell }) => {
		const {
			apiRef,
			tableDateRange,
			employee,
			setVirtualization,
			setVirtualTotals,
			setRows,
			setDeleteRealPunches,
			setLoadingGettingPunchesAndExceptions,
		} = useContext(Context);

		//const { handlerAlert } = useContext(GlobalContext);

		// eslint-disable-next-line
		const [loading, setLoading] = useState(false);

		const background = (punch, theme) => {
			if ((punch.exception || punch.missing) && punch.hover) {
				return theme.palette.error.dark;
			} else if ((punch.exception || punch.missing) && !punch.hover) {
				return theme.palette.error.main;
			} else {
				return theme.palette.success.main;
			}
		};

		const deletePunchSimulation = () => {
			if (params.field === "punch_in") {
				params.row.punch_in = params.row.punch_in.filter(
					(p) => p.id !== punch.id
				);
			} else {
				params.row.punch_out = params.row.punch_out.filter(
					(p) => p.id !== punch.id
				);
			}

			apiRef.current.updateRows([params?.row]);

			const punches = [];

			for (let row of apiRef.current
				.getAllRowIds()
				.map((id) => apiRef.current.getRow(id))) {
				row.punch_in
					.filter((punch) => !punch.missing)
					.map((punch) => {
						const dateTime = moment.tz(
							`${punch.date_time}:00`,
							moment.tz.guess()
						);

						const punch_in = {
							id: punch.id,
							punchDateTimeUTC: dateTime
								.utc()
								.format("YYYY-MM-DDTHH:mm:ss"),
							timeZone: moment.tz.guess(),
						};

						return punches.push(punch_in);
					});

				row.punch_out
					.filter((punch) => !punch.missing)
					.map((punch) => {
						const dateTime = moment.tz(
							`${punch.date_time}:00`,
							moment.tz.guess()
						);

						const punch_out = {
							id: punch.id,
							punchDateTimeUTC: dateTime
								.utc()
								.format("YYYY-MM-DDTHH:mm:ss"),
							timeZone: moment.tz.guess(),
						};

						return punches.push(punch_out);
					});
			}

			const body = {
				start_dtm: tableDateRange[0].format("YYYY-MM-DDTHH:mm:ss"),
				end_dtm: tableDateRange[1]
					.add(23, "hours")
					.add(59, "minutes")
					.add(59, "seconds")
					.format("YYYY-MM-DDTHH:mm:ss"),
				employee_id: employee.length > 0 ? employee[0]?.id : undefined,
				punches: punches,
			};

			if (punch.id > 0) {
				setDeleteRealPunches((prev) => [...prev, punch.id]);
			}

			gettingSimulatePunches(
				setLoadingGettingPunchesAndExceptions,
				body,
				setRows,
				setVirtualization,
				setVirtualTotals
			);
		};

		const props = punch.exception
			? {
					onClick: () => {
						console.log("row", params.row);
						setAddOpenPaycode(true);
						setAction("exception");
						setCell({
							column: undefined,
							row: params?.row?.date,
							employee_id: params?.row?.person_number,
						});
					},
					onDelete: punch.missing
						? undefined
						: (data) => {
								if (loading) {
									console.log("loading...");
								} else {
									//deletingPunch(setLoading, punch.date, `${punch.time}:00`, params.row.person_number, reloading, handlerAlert)
									deletePunchSimulation();
								}
						  },
			  }
			: {
					onDelete: () => {
						if (loading) {
							console.log("loading...");
						} else {
							//deletingPunch(setLoading, punch.date, `${punch.time}:00`, params.row.person_number, reloading, handlerAlert)
							deletePunchSimulation();
						}
					},
			  };

		return (
			<>
				{punch.missing ? (
					<Chip
						{...props}
						disabled={params?.row?.open_period.open === false}
						color="error"
						label={"Marca Omitida"}
						onMouseOver={() => {
							if (params.field === "punch_in") {
								params.row.exceptions.find(
									(e) =>
										e.total_span_index ===
											punch.total_span_index &&
										e.in_punch_flag === true
								).hover = true;
								apiRef.current.updateRows([params?.row]);
							} else {
								params.row.exceptions.find(
									(e) =>
										e.total_span_index ===
											punch.total_span_index &&
										e.in_punch_flag === false
								).hover = true;
								apiRef.current.updateRows([params?.row]);
							}
						}}
						onMouseOut={() => {
							if (params.field === "punch_in") {
								params.row.exceptions.find(
									(e) =>
										e.total_span_index ===
											punch.total_span_index &&
										e.in_punch_flag === true
								).hover = false;
								apiRef.current.updateRows([params?.row]);
							} else {
								params.row.exceptions.find(
									(e) =>
										e.total_span_index ===
											punch.total_span_index &&
										e.in_punch_flag === false
								).hover = false;
								apiRef.current.updateRows([params?.row]);
							}
						}}
						sx={{
							width: "160px",
							background: (theme) => background(punch, theme),
						}}
					/>
				) : (
					<Chip
						{...props}
						disabled={params?.row?.open_period.open === false}
						color={punch.exception ? "error" : "success"}
						icon={
							punch.exception ? (
								<WarningIcon
									sx={{ cursor: "pointer", p: 0.25 }}
									onClick={() => {
										console.log("warning");
									}}
								/>
							) : (
								<AssignmentIndIcon sx={{ p: 0.25 }} />
							)
						}
						label={`${punch.time}`}
						onMouseOver={() => {
							if (punch.exception) {
								if (params.field === "punch_in") {
									params.row.exceptions.find(
										(e) =>
											e.total_span_index ===
												punch.total_span_index &&
											e.in_punch_flag === true
									).hover = true;
									apiRef.current.updateRows([params?.row]);
								} else {
									params.row.exceptions.find(
										(e) =>
											e.total_span_index ===
												punch.total_span_index &&
											e.in_punch_flag === false
									).hover = true;
									apiRef.current.updateRows([params?.row]);
								}
							}
						}}
						onMouseOut={() => {
							if (punch.exception) {
								if (params.field === "punch_in") {
									params.row.exceptions.find(
										(e) =>
											e.total_span_index ===
												punch.total_span_index &&
											e.in_punch_flag === true
									).hover = false;
									apiRef.current.updateRows([params?.row]);
								} else {
									params.row.exceptions.find(
										(e) =>
											e.total_span_index ===
												punch.total_span_index &&
											e.in_punch_flag === false
									).hover = false;
									apiRef.current.updateRows([params?.row]);
								}
							}
						}}
						deleteIcon={
							loading ? (
								<CircularProgress size={20} color="inherit" />
							) : (
								<DeleteIcon />
							)
						}
						sx={{
							width: "160px",
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							"& .MuiChip-icon": {
								marginLeft: 1,
							},
							"& .MuiChip-label": {
								flexGrow: 1,
								textAlign: "center",
							},
							background: (theme) => background(punch, theme),
							border:
								punch.total_span_index < 0
									? `1px dashed white`
									: undefined,
							opacity: punch.total_span_index < 0 ? 0.5 : 1,
						}}
					/>
				)}
			</>
		);
	}
);

const PunchCell = memo(({ params, setAddOpenPaycode, setAction, setCell }) => {
	const regex = /auto-generated-row-null/;

	return (
		<>
			{regex.test(params?.id) ? (
				<></>
			) : (
				<Box
					sx={{
						width: "100%",
						display: "grid",
						placeItems: "center",
						alignItems: "center",
						alignContent: "center",
						gap: "10px",
						p: 1.5,
						height: "100%",
					}}
				>
					{params?.value
						?.sort(
							(a, b) => a.total_span_index - b.total_span_index
						)
						.map((punch, index) => (
							<PunchChip
								key={`${params?.field}-${params?.id}-${punch.total_span_index}-${index}`}
								punch={punch}
								params={params}
								setAddOpenPaycode={setAddOpenPaycode}
								setAction={setAction}
								setCell={setCell}
							/>
						))}
				</Box>
			)}
		</>
	);
});

export { PunchCell, EditPunchCell };
